let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hoRNa")).then(() => parcelRequire('7IGR2'));